// ui/components/CapacitacionDetalle.jsx  (presentacional: view model in, callbacks out; la tarjeta de imágenes llega como children)
import React from 'react';
import SectionCard from '../../../shared/ui/SectionCard.jsx';
import PillButton from '../../../shared/ui/PillButton.jsx';
import AsistenteCard from '../../../shared/ui/AsistenteCard.jsx';
import Campo from '../../../shared/ui/Campo.jsx';
import EmptyBox from '../../../shared/ui/EmptyBox.jsx';
import { formatFechaDetalle } from '../../../shared/domain/fecha';

const CapacitacionDetalle = ({ data, fotos = {}, onEditAsistentes, children }) => {
  const asistentes = data.asistentes_detalle;

  return (
    <>
      <SectionCard title="Información general" subtitle="Datos registrados al crear la capacitación.">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '18px 24px' }}>
          <Campo label="Nombre de capacitación" value={data.nombre_capacitacion} />
          <Campo label="Actividades" value={data.actividad_nombre} />
          <Campo label="Capacitador / responsable" value={data.responsable} />
          <Campo label="Fecha" value={formatFechaDetalle(data.fecha)} />
          <Campo label="Municipio" value={data.municipio_nombre} />
          <Campo label="Localidad" value={data.localidad_nombre} />
        </div>
        <div className="mt-3">
          <Campo label="Descripción" value={data.descripcion} />
        </div>
        <div className="mt-3">
          <Campo label="Materiales utilizados" value={data.materiales} />
        </div>
      </SectionCard>

      <SectionCard
        title={`Asistentes (${asistentes.length})`}
        subtitle="Productores registrados en esta capacitación."
        actions={
          <span>
            <PillButton icon="fa-user-plus" onClick={onEditAsistentes}>
              Editar asistentes
            </PillButton>
          </span>
        }>
        {asistentes.length === 0 ? (
          <EmptyBox>Aún no hay asistentes registrados</EmptyBox>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: 12 }}>
            {asistentes.map(asistente => (
              <AsistenteCard key={asistente.id} asistente={asistente} fotoUrl={fotos[asistente.uuid]} fullWidth />
            ))}
          </div>
        )}
      </SectionCard>
      {children}
    </>
  );
};

export default CapacitacionDetalle;
